module.exports = __webpack_public_path__ + "static/laboheme6s-890f44e8b8b9f19b9775fcd51c009eb2.jpg";